import _ from 'lodash';
import GraphqlBuilder from "utils/request/graphql/builder";
import { bookingConstants } from "utils/constants/booking-constants";
import { constantsGraphql } from 'utils/constants/constants'
import QueryManagementTimeslotCapacity from 'graphql/queries/management/QueryManagementTimeslotCapacity'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import HelperString from 'utils/helper-string'

export default class FetchManagementTimeslotCapacity {

	static fetch( { building = {}, floor = {}, room = {}, dates, callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		// Create the builder
		let graphqlBuilder = new GraphqlBuilder();

		let hasArray = false;

		if( Array.isArray( building ) ) {
			hasArray = true;
			
			// loop through the buildings
			building.forEach( item => {
				const timeslots = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = this.addQueryByDates( graphqlBuilder, item, {}, {}, timeslots, dates );
			});
		}

		if( Array.isArray( floor ) && hasArray === false ) {
			hasArray = true;
			
			// loop through the buildings
			floor.forEach( item => {
				const timeslots = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = this.addQueryByDates( graphqlBuilder, {}, item, {}, timeslots, dates );
			});
		} else if( hasArray ) {
			return;
		}

		if( Array.isArray( room ) && hasArray === false ) {
			hasArray = true;
			// loop through the buildings
			room.forEach( item => {
				const timeslots = _.get( item, 'timeslots_through', [] );
				
				graphqlBuilder = this.addQueryByDates( graphqlBuilder, {}, {}, item, timeslots, dates );
			});
		} else if( hasArray ) {
			return;
		}
		
		graphqlBuilder.setOnStart( () => {
			return this.onStart(callbackStart);
		} );
		
		graphqlBuilder.setOnSuccess( result => {
			return this.onSuccess(result, callbackSuccess);
		} )
		
		graphqlBuilder.setOnError( result => {
			return this.onError(result, callbackError);
		} );
		
		if( _.size( graphqlBuilder.queries ) > 0 ) {
			graphqlBuilder.execute();
			return;
		}
		
		this.onSuccess( null, callbackSuccess )
	}
	
	static onError( result, callbackError = null ) {
		if( callbackError !== null && _.isFunction( callbackError ) ) {
			callbackError( result );
		}
	}
	
	static onStart( callbackStart = null ) {
		if( callbackStart !== null && _.isFunction( callbackStart ) ) {
			callbackStart();
		}
	}
	
	/**
	 * Function for creating the occupied timeslots by employee guid
	 * @param result
	 * @param callbackSuccess
	 */
	static onSuccess( result, callbackSuccess = null ) {
		const timeslotsOccupied = {};
		
		if( result !== null ) {
			_.forEach( result, ( item, key ) => {
				const bookings = _.get( item, 'employee_bookings', {} )
				if( !_.isEmpty( bookings ) ) {
					timeslotsOccupied[ key ] = bookings
				}
			});
		}
		
		if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
			callbackSuccess( timeslotsOccupied );
		}
	}
	
	/**
	 *
	 * @param graphqlBuilder
	 * @param bookings
	 * @returns {*}
	 */
	static addQueryByBookings = ( graphqlBuilder, bookings = [] ) => {
		_.forEach( bookings, booking => {
			const building = _.get( booking, 'building', {} );
			const floor = _.get( booking, 'floor', {} );
			const room = _.get( booking, 'room', {} );
			const slot = _.get( booking, 'timeslot', {} );
			const buildingParkingSpace = _.get( booking, 'building_parking_space', {} );
			
			if( !HelperString.isEmptyString( slot.guid ) ) {
				const key = FetchTimeslotCapacity.keyByBooking( booking );
				
				const variables = {
					building_guid: _.get( building, 'guid', null ),
					floor_guid: _.get( floor, 'guid', null ),
					room_guid: _.get( room, 'guid', null ),
					timeslot_guid: _.get( slot, 'guid', null ),
					building_parking_space_guid: _.get( buildingParkingSpace, 'guid', null ),
					kind: _.get( slot, 'kind', null ),
					booking_date: booking.booking_date,
					//active: constantsGraphql.YES_NO
					active: constantsGraphql.YES
				};
				
				graphqlBuilder.addQuery( key, QueryManagementTimeslotCapacity, variables )
			}
		});
		
		return graphqlBuilder;
	}
	
	/**
	 *
	 * @param graphqlBuilder
	 * @param building
	 * @param floor
	 * @param room
	 * @param timeslots
	 * @param dates
	 * @returns {*}
	 */
	static addQueryByDates = ( graphqlBuilder, building = {}, floor = {}, room = {}, timeslots, dates ) => {
		// Check if it is an array, so not make it one
		if( !_.isArray( dates ) ) {
			dates = [ dates ];
		}
		
		const buildingGuid = _.get( building, 'guid', null );
		const floorGuid = _.get( floor, 'guid', null );
		const roomGuid = _.get( room, 'guid', null );
		
		_.forEach( dates, date => {
			_.forEach( timeslots, timeslot => {
				const kind = _.get( timeslot, 'kind', null );
				const timeslotGuid = _.get( timeslot, 'guid', null );
				
				graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot ), QueryManagementTimeslotCapacity, {
					building_guid: buildingGuid,
					floor_guid: floorGuid,
					room_guid: roomGuid,
					timeslot_guid: timeslotGuid,
					kind: kind,
					booking_date: date,
					active: constantsGraphql.YES
				});
				
				switch( kind ) {
					case bookingConstants.LUNCH:
						// Without room
						graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot ), QueryManagementTimeslotCapacity, {
							building_guid: buildingGuid,
							floor_guid: roomGuid,
							room_guid: null,
							timeslot_guid: timeslotGuid,
							kind: kind,
							booking_date: date,
							active: constantsGraphql.YES
						});
						
						// Without floor
						graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot ), QueryManagementTimeslotCapacity, {
							building_guid: buildingGuid,
							floor_guid: null,
							room_guid: null,
							timeslot_guid: timeslotGuid,
							kind: kind,
							booking_date: date,
							active: constantsGraphql.YES
						});
						break;
					
					case bookingConstants.TRANSPORT:
						const buildingParkingSpace = _.get( timeslot, 'building_parking_space', {} );
						const transportKind = _.get( timeslot, 'transport_kind', null );
						
						if( !_.isEmpty( buildingParkingSpace ) ) {
							graphqlBuilder.addQuery( FetchTimeslotCapacity.key( date, timeslot, transportKind, buildingParkingSpace ), QueryManagementTimeslotCapacity, {
								building_guid: buildingGuid,
								floor_guid: null,
								room_guid: null,
								timeslot_guid: timeslotGuid,
								transport_kind: transportKind,
								building_parking_space_guid: _.get( buildingParkingSpace, 'guid', null ),
								kind: kind,
								booking_date: date,
								active: constantsGraphql.YES
							} );
						}
						break;
				}
			});
		});
		
		return graphqlBuilder;
	}
}
